<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row justify-content-between header">
          <div class="col-md-8">
            <h2>Extrato Social</h2>
            <p>Doações recorrentes estão exibindo apenas o valor doado no primeiro mês</p>
          </div>
          <div class="col-md-4">
            <router-link to="/projects" class="btn create-project">Realizar doação</router-link>
            <router-link to="/descontosdobem" class="btn create-project">Descontos do Bem</router-link>
          </div>
        </div>
        <div class="row">
          
        </div>
        <div class="row" v-if="user">
          <table class="donations table" v-if="donations && donations.length > 0">
            <thead>
              <th>Data</th>
              <th>Projeto</th>
              <th>Valor</th>
              <th>Tipo</th>
              <th>Situação</th>
              <th>Detalhes</th>
            </thead>
            <tbody>
              <tr v-for="d in donations" v-bind:key="d.DonationId">
                <td>{{getDate(d.timestamp)}}</td>
                <td>{{(d.Project.Info) ? d.Project.Info.title : ''}}</td>
                <td>R$ {{d.value}}</td>
                <td>{{(d.type == 'single') ? 'Simples' : 'Recorrente'}}</td>
                <td>{{getStatus(d.paymentStatus)}}</td>
                <td><a href="" v-on:click.stop.prevent="showDonationDetail(d)">Ver Detalhes</a></td>
              </tr>
            </tbody>
          </table>
          <h4 class="projects-empty" v-if="donations && donations.length == 0">Você não possui doações. Clique <router-link to="/projects">aqui</router-link> para fazer uma doação!</h4>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Loading v-if="loading" message="Aguarde, estamos atualizando seu extrato..."></Loading>
    <b-modal ref="donationDetail" hide-footer title="Detalhes da Doação">
      <div class="d-block text-center" v-if="donationModal">
        <h3>Projeto: {{(donationModal.Project.Info) ? donationModal.Project.Info.title : ''}}</h3>
        <p>Valor: R$ {{donationModal.value}}</p>
        <p v-if="donationModal.paymentMethod">Forma de pagamento: {{donationModal.paymentMethod}}</p>
        <p>Tipo de Doação: {{(donationModal.type == 'single') ? 'Simples' : 'Recorrente'}}</p>
        <p v-if="donationModal.paymentMethod">Forma de Pagamento: {{donationModal.paymentMethod}} / {{donationModal.paymentType}}</p>
        <p>Status: {{getStatus(donationModal.paymentStatus)}}</p>
      </div>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Fechar</b-btn>
    </b-modal>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import auth from '../services/auth'
import Functions from '../utils/functions'
import { API } from '../services/api'

export default {
  name: 'MyDonations',
  components: {
    Header,
    Footer,
    Loading,
  },
  data () {
    return {
      user: null,
      donations: null,
      donationModal: null,
      loading: true
    }
  },
  created(){
    this.getProfile()
  },
  mounted (){
    
  },
  methods: {
    getProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((result) => {
        this.user = result.body.user;
        this.getDonations();
      }, (err) => {
        auth.logout();
        this.$router.push('/login');
      });
    },
    getDonations(){
      this.$http.get(API.Profile.donations, {headers: auth.getHeaders()}).then((result) => {
        this.loading = false;
        this.donations = result.body.donations.filter((d) => {
          return d.paymentStatus != 'incomplete';
        })
        this.donations.sort(function(x, y){
          return y.timestamp - x.timestamp;
        })
      });
    },
    getDate(timestamp){
      if(timestamp.toString().length < 11){
        timestamp = parseInt(timestamp.toString() + "000")
      }
      var date = new Date(parseInt(timestamp));
      return date.toLocaleDateString()
    },
    getStatus(status){
      switch(status){
        case 'incomplete':
          return 'Não Concluído';
          break;
        case 'waiting':
          return 'Aguardando Pagamento';
          break;
        case 'waiting_payment':
          return 'Aguardando Pagamento';
          break;
        case 'authorized':
          return 'Pagamento Autorizado';
          break;
        case 'not_authorized':
          return 'Não Autorizado';
          break;
        case 'paid':
          return 'Pago';
          break;
      }
    },
    showDonationDetail(donation){
      this.donationModal = donation
      this.$refs.donationDetail.show()
    },
    hideModal(){
      this.$refs.donationDetail.hide()
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header{
  a{
    float: left;
    margin-left: 20px;
    &:last-child{
      float: right;
      margin-left: 0px;
    }
  }
}
h2{
  color: #00AE39;
  font-family: RalewayRegular;
}
.projects-empty{
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-top: 20px;
}
.create-project{
  color: #fff;
  background-color: #00AE39;
  text-decoration: none;
  &:hover{
    background-color: #333;
  }
}
a{
  text-decoration: none;
  color: #00AE39;
}
.donations{
  width: 100%;
  margin-top: 20px;
  display: table;
  thead{
    font-family: RalewayBold;
  }
  tbody{
    tr{
      font-family: RalewayRegular;
      a{
        text-decoration: none;
        color: #00AE39;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyDonations.vue